<template>
    <el-container class="plugin-info">
        <el-main>
            <el-row>
                <el-col :span="18">
                    <div class="plugin" v-loading="loading">
                        <img :src="list.pic_url" alt="">
                        <div class="plugin-name">{{ list.display_name }}</div>
                        <div>请注意：此应用必须要先购买禾匠商城主应用才能使用</div>
                        <div class="plugin-buy">
                            <div class="plugin-price">￥{{ list.price }}</div>
                            <router-link :to="'/dashboard/plugin-order/edit?id=' + list.id">
                                <el-button type="primary" class="to-buy" round>立即购买</el-button>
                            </router-link>
                        </div>
                    </div>
                    <div class="plugin-content" v-html="list.content"></div>
                </el-col>
                <el-col class="about">
                    <div>
                        <span>相关应用</span>
                    </div>
                    <div class="plugin-list">
                        <div class="plugin-item" v-for="item in plugin" :key="item.id" v-if="list.id != item.id">
                            <router-link :to="'/plugin/plugin-info?id=' + item.id">
                                <img :src="item.img" alt="">
                                <div style="padding-top: 5px;color: #353535;">{{ item.name }}</div>
                                <div class="item-price">￥{{ item.price }}</div>
                            </router-link>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            id: null,
            list: [],
            plugin: []
        }
    },
    created() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id
            this.getList()
        }
    },
    methods: {
        getList() {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'user/plugin/detail',
                    params: {
                        id: this.id
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.list = e.data.data
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        }
    }
}
</script>

<style scoped>
    .plugin-info{
        width: 1200px;
        margin: 10px auto;
    }

    .el-main{
        padding: 0;
    }

    .plugin{
        background-color: #fff;
        padding: 25px;
        height: 150px;
        font-size: 14px;
        color: #999;
    }

    .plugin img{
        height: 100%;
        float: left;
        border-radius: 15px;
        margin-right: 40px;
    }

    .plugin-name{
        margin-top: 20px;
        font-size: 20px;
        margin-bottom: 10px;
        color: #353535;
    }

    .plugin-buy{
        font-size: 20px;
        margin-top: 35px;
        color: #ff5c5c;
        height: 40px;
        line-height: 40px;
    }

    .plugin-price{
        display: inline-block;
        width: auto;
    }

    .to-buy{
        float: right;
        height: 100%;
    }

    .plugin-content{
        margin-top: 20px;
        padding: 20px;
        background-color: #fff;
    }

    .about{
        padding: 20px;
        width: 280px;
        position: fixed;
        top: 90px;
        right: 50%;
        margin-right: -600px;
        background-color: #fff;
    }

    .about span{
        display: inline-block;
        font-size: 16px;
        padding-left: 15px;
        margin-bottom: 10px;
        border-left: 5px solid #409EFF;
    }

    .plugin-list{
        margin-top: 10px;
        padding-top: 20px;
        border-top: 1px solid #e2e2e2;
        background-color: #fff;
    }

    .plugin-item{
        height: 60px;
        margin-top: 20px;
    }

    .plugin-item:first-of-type{
        margin-top: 0px;
    }

    .plugin-item img{
        height: 100%;
        border-radius: 10px;
        float: left;
        margin-right: 25px;
    }

    .item-price{
        margin-top: 15px;
        color: #ff5c5c;
    }

    @media screen and (max-width:767px){
        .el-col-18{
            width: auto;
        }
        .about{
            display: none;
        }
        .el-main .plugin-info{
            width: 100%;
        }
        .el-col-18 .plugin{
            height: auto;
            padding: 1rem;
        }
        .el-col-18 .plugin img{
            margin-right: 1rem;
            height: 8rem;
            width: 8rem;
        }
    }
</style>
